import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';

export interface PestModelSubscriptionPayload {
  idFinca: number;
  modelCode: string;
  isEnabled?: boolean;
  notifyInfo?: boolean;
  notifyWarning?: boolean;
  notifyAlert?: boolean;
  channel?: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class PestModelsSubscriptionService {
  constructor(private $http: SuperHttpClientProvider) {}

  upsertSubscription(payload: PestModelSubscriptionPayload): Observable<any> {
    return this.$http.default.post('/pest-model/subscription', payload);
  }

  disableSubscription(idFinca: number, modelCode: string): Observable<any> {
    return this.$http.default.delete(
      `/pest-model/subscription/${idFinca}/${modelCode}`
    );
  }
}
